<template>
  <b-row>
    <b-col>
      <component-header
        title="Edit Privacy Setting"
        :isLoading="loading"
        :hasback="true"
        :hasSearch="false"
        :hasCreate="false"
        :hasReload="false"
        @back-press="backBtn"
      />
      <b-card>
        <div class="selections align-items-center mb-4">
          <div class="type-selection d-flex align-items-center">
            <label class="mr-2 mt-1">Select Type:</label>
            <b-form-radio-group v-model="selectedType" class="radio-buttons">
              <b-form-radio value="termsCondition"
                >Terms & Condition</b-form-radio
              >
              <b-form-radio value="privacyPolicy">Privacy Policy</b-form-radio>
            </b-form-radio-group>
          </div>
          <div class="scope-selection align-items-center ml-md-4 mt-3 mt-md-0">
            <label class="mr-2 mt-1">Select Scope:</label>
            <b-form-radio-group v-model="selectedScope" class="radio-buttons">
              <b-form-radio value="customer">Customer</b-form-radio>
              <b-form-radio value="seller">Seller</b-form-radio>
              <b-form-radio value="agent">Agent</b-form-radio>
            </b-form-radio-group>
          </div>
        </div>
        <b-form-group>
          <b-form-input
            v-model="title"
            placeholder="Enter Title"
          ></b-form-input>
        </b-form-group>
      </b-card>

      <!-- Updated v-for loop with unique keys -->
      <b-card v-for="(section, index) in subSections" :key="section.id">
        <div>
          <div class="d-flex justify-content-between align-items-center">
            <label>
              Sub Section {{ index + 1 }}
              <span v-if="index === 0" class="text-muted">(By Default)</span>
            </label>
            <div class="button-group">
              <b-button
                v-if="index > 0"
                variant="link"
                class="p-0"
                @click="removeSubSection(index)"
              >
                <span class="fa fa-minus-circle fa-2x text-danger"></span>
              </b-button>
              <b-button variant="link" class="p-0" @click="addSubSection">
                <span class="fa fa-plus-circle fa-2x text-success"></span>
              </b-button>
            </div>
          </div>
          <b-form-group>
            <b-form-input
              v-model="section.subtitle"
              placeholder="Enter Title"
            ></b-form-input>
          </b-form-group>
          <vue-editor v-model="section.description"></vue-editor>
        </div>
      </b-card>

      <div class="buttons d-flex justify-content-center mb-4">
        <b-button variant="danger" @click="cancel">CANCEL</b-button>
        <b-button variant="primary" @click="update" class="ml-2"
          >UPDATE</b-button
        >
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";

export default {
  name: "EditPrivacySetting",
  components: {
    VueEditor,
    ComponentHeader,
  },
  props: ["id", "userData"],
  data() {
    return {
      loading: false,
      selectedType: "",
      selectedScope: "",
      title: "",
      subSections: [{ id: Date.now(), subtitle: "", description: "" }],
    };
  },
  computed: {
    ...mapGetters({
      editPrivacySettingData: "privacySetting/GetEditPrivacySettingData",
    }),
  },
  async mounted() {
    let privacyItemId = this.$route.params.data;
    await this.loadPrivacySetting(privacyItemId);
    this.subSections = this.editPrivacySettingData.sections.map((section) => ({
      ...section,
      id: Date.now() + Math.random(), // Ensuring each section has a unique ID
    }));
    this.title = this.editPrivacySettingData.title;
    this.selectedScope = this.editPrivacySettingData.slug;
    this.selectedType = this.editPrivacySettingData.content;
  },
  methods: {
    backBtn() {
      this.$router.push({ path: "/privacy-setting/" });
    },
    async loadPrivacySetting(privacyItemId) {
      try {
        const response = await this.$store.dispatch(
          "privacySetting/viewPrivacySettingAction",
          privacyItemId
        );
      } catch (error) {
        console.error("Error loading privacy setting:", error);
      }
    },
    addSubSection() {
      this.subSections.push({
        id: Date.now() + Math.random(), // Unique ID for each new subsection
        subtitle: "",
        description: "",
      });
    },
    removeSubSection(index) {
      if (this.subSections.length > 1) {
        this.subSections.splice(index, 1);
      }
    },
    cancel() {
      this.$router.push({ path: "/privacy-setting/" });
    },
    async update() {
      const sections = this.subSections.map((section) => ({
        subtitle: section.subtitle,
        description: section.description,
      }));

      const data = {
        id: this.$route.params.data._id,
        data: {
          tenant: this.$currentUserData._id,
          sections: sections,
          title: this.title,
          slug: this.selectedScope,
          content: this.selectedType,
        },
      };

      await this.$store
        .dispatch("privacySetting/editPrivacySettingAction", data)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Privacy setting updated successfully!!",
            type: "success",
          });
          this.$router.push({ path: "/privacy-setting/" });
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Failed to update privacy setting",
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.card {
  margin-top: 20px;
}

.selections {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

@media (min-width: 768px) {
  .selections {
    flex-direction: row;
  }
}

.type-selection,
.scope-selection {
  display: flex;
  align-items: center;
}

.radio-buttons {
  display: flex;
  gap: 5px;
}

.buttons {
  width: 20%;
  height: 35px;
  margin: auto;
  margin-top: 30px;
}
</style>
